// import "../styles/OduChassis.css";

// // dummy images (replace with real chassis images)
// import chassis20 from "../images/20”chassis(LxWxH)–780x300x550mm.jpeg";
// import chassis22 from "../images/22”chassis(LxWxH)–810x307x570mm.jpeg";
// import chassis26 from "../images/26”chassis(LxWxH)–855x 310x655 mm.jpeg";
// import chassis32 from "../images/32”chassis(LxWxH)–1025x417x920mm.jpeg";

// export default function OduChassis() {
//   const chassisData = [
//     {
//       name: '20" Chassis',
//       size: "780 x 300 x 550 mm",
//       img: chassis20
//     },
//     {
//       name: '22" Chassis',
//       size: "810 x 307 x 570 mm",
//       img: chassis22
//     },
//     {
//       name: '26" Chassis',
//       size: "855 x 310 x 655 mm",
//       img: chassis26
//     },
//     {
//       name: '32" Chassis',
//       size: "1025 x 417 x 920 mm",
//       img: chassis32
//     }
//   ];

//   return (
//     <section className="odu-section">

//       <div className="container">

//         {/* HEADER */}
//         <div className="odu-header">
//           <h2>ODU Chassis Range</h2>
//           <p>
//             Precision-engineered outdoor unit chassis designed for durability and performance
//           </p>
//         </div>

//         {/* GRID */}
//         <div className="odu-grid">

//           {chassisData.map((item, index) => (
//             <div className="odu-card" key={index}>

//               <div className="odu-image">
//                 <img src={item.img} alt={item.name} />
//               </div>

//               <div className="odu-content">
//                 <h3>{item.name}</h3>
//                 <p className="size">{item.size}</p>
//               </div>

//             </div>
//           ))}

//         </div>

//       </div>

//     </section>
//   );
// }













import "../styles/OduChassis.css";

// images
import heroImage from "../images/ProductGallery.jpeg"; // 👈 add a large banner image
import chassis20 from "../images/20Chassis.jpeg";
import chassis22 from "../images/22Chassis.jpeg";
import chassis26 from "../images/26Chassis.jpeg";
import chassis32 from "../images/32Chassis.jpeg";

export default function OduChassis() {
  const chassisData = [
    {
      name: '20" Chassis',
      size: "780 x 300 x 550 mm",
      img: chassis20
    },
    {
      name: '22" Chassis',
      size: "810 x 307 x 570 mm",
      img: chassis22
    },
    {
      name: '26" Chassis',
      size: "855 x 310 x 655 mm",
      img: chassis26
    },
    {
      name: '32" Chassis',
      size: "1025 x 417 x 920 mm",
      img: chassis32
    }
  ];

  return (
    <section className="odu-section">

      {/* FULL SCREEN HERO IMAGE */}
      <div className="odu-hero">
        <img src={heroImage} alt="ODU Manufacturing" />
        <div className="hero-overlay">
          <h1>ODU Chassis Manufacturing</h1>
          <p>Precision Engineering for High Performance HVAC Systems</p>
        </div>
      </div>

      <div className="container">

        {/* HEADER */}
        <div className="odu-header">
          <h2>ODU Chassis Range</h2>
          <p>
            Precision-engineered outdoor unit chassis designed for durability and performance
          </p>
        </div>

        {/* GRID */}
        <div className="odu-grid">

          {chassisData.map((item, index) => (
            <div className="odu-card" key={index}>

              <div className="odu-image">
                <img src={item.img} alt={item.name} />
              </div>

              <div className="odu-content">
                <h3>{item.name}</h3>
                <p className="size">{item.size}</p>
              </div>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}